import { FC } from 'react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import { InputWrapper } from '../../../styled'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { useFormik } from 'formik'
import { useAFormHandler } from 'analytics/hooks'
import PermissionCheck from 'views/components/PermissionCheck/PermissionCheck'
import { AButton } from 'views/components/Analytics'
import { DealPeriod, DealPeriodsTypes } from 'modules/domain/deal/types'
import { FormDatePicker } from 'views/components/form/FormDatePicker'
import { FormLabel } from '../../styled'

export const DealPeriodForm: FC<{
  dealPeriod?: DealPeriod
  dealId: string
  onSuccess: () => Promise<void>
  type: DealPeriodsTypes
}> = ({ dealPeriod, onSuccess, type, dealId }) => {
  const { t } = useTranslation('deal')
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik({
    initialValues: {
      start_date: dealPeriod ? dealPeriod.start_date : null,
      end_date: dealPeriod ? dealPeriod.end_date : null,
      period_type: type,
      deal: dealId,
    },
    onSubmit: formHandler(
      async () => {
        if (dealPeriod) {
          await apiClient.patch(endpoints.dealPeriods(dealPeriod.id), formik.values)
        } else {
          await apiClient.post(endpoints.dealPeriods(), formik.values)
        }
      },
      {
        onSuccess: onSuccess,
        onError: (error) => {
          formik.setErrors(error.errors)
        },
      },
    ),
  })

  return (
    <>
      <InputWrapper>
        <FormDatePicker
          label={<FormLabel>{t('contractSign.fillDateFrom')}</FormLabel>}
          fieldName="start_date"
          id="deal_periond_start_date"
          formik={formik}
          size="small"
          labelWidth={280}
          short={false}
        />
        <FormDatePicker
          label={<FormLabel>{t('contractSign.fillDateTo')}</FormLabel>}
          fieldName="end_date"
          id="deal_periond_end_date"
          formik={formik}
          size="small"
          labelWidth={280}
          short={false}
        />
      </InputWrapper>
      <PermissionCheck scope={['deals.add_dealperiod']}>
        <AButton
          id="approveDealPeriod"
          progress={formProgress}
          onClick={formik.submitForm}
          color="primary"
          size="medium"
        >
          {t('contractSign.set')}
        </AButton>
      </PermissionCheck>
    </>
  )
}
